/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>
/* tslint:disable */

module DealerwareWebComponents {

    'use strict';

    export class PdfHelperService {

        public static $inject : string[ ] = [
            '$q',
            '$http',
            '$window',
            'MobilityAuthenticationStrategy',
            '$mobilityCompanyAuthentication',
            'MobilityWebCoreEnvironmentConfig'
        ];

        constructor(
            public $q                               : ng.IQService,
            public $http                            : ng.IHttpService,
            public $window                          : ng.IWindowService,
            public MobilityAuthenticationStrategy   : any,
            public $mobilityCompanyAuthentication   : any,
            public MobilityWebCoreEnvironmentConfig : any
        ) {
        }

        public getPdfBlob (args: any) : ng.IPromise<{}> {

            var deferred = this.$q.defer();

            this.$http({
                method                      : 'GET',
                responseType                : 'blob',
                url                         : this.MobilityWebCoreEnvironmentConfig.apiServer + args.endpoint,
                headers: {
                    'Authorization'         : this.MobilityAuthenticationStrategy.authenticationToken,
                    'Company-Authorization' : this.$mobilityCompanyAuthentication.companyToken
                }
            })
                .then( ( response: any ) => {
                    deferred.resolve(response);
                    return response;
                }, ( response: any ) => {

                    // API error data is also a Blob, but it needs to be parsed for the text.
                    //
                    var reader = new FileReader();
                    reader.addEventListener('loadend', ( e: any ) => {
                        try {
                            deferred.reject(JSON.parse(e.srcElement.result));
                        }
                        catch (e) {
                            deferred.reject(e.srcElement.result);
                        }
                    });

                    reader.readAsText(response.data);

                    return response;
                });

            return deferred.promise;
        }

        public streamPdfToNewWindow ( dataStream: any ) : void {

            this.$window.open(
                this.$window.URL.createObjectURL(dataStream)
            );
        }
    }

    getDealerwareWebComponentsModule().factory(
        'PdfHelperService', (
            $q                               : ng.IQService,
            $http                            : ng.IHttpService,
            $window                          : ng.IWindowService,
            MobilityAuthenticationStrategy   : any,
            $mobilityCompanyAuthentication   : any,
            MobilityWebCoreEnvironmentConfig : any
        ) => new PdfHelperService (
            $q,
            $http,
            $window,
            MobilityAuthenticationStrategy,
            $mobilityCompanyAuthentication,
            MobilityWebCoreEnvironmentConfig
        )
    );
}

